import * as React from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/List": List, "@mui/material/ListItemButton": ListItemButton, "@mui/material/ListItemText": ListItemText, "@mui/material/MenuItem": MenuItem, "@mui/material/Menu": Menu } } });
export default ClientProvider;
